import { render, staticRenderFns } from "./AppNotificationToasts.vue?vue&type=template&id=c2768fb4&"
import script from "./AppNotificationToasts.vue?vue&type=script&lang=js&"
export * from "./AppNotificationToasts.vue?vue&type=script&lang=js&"
import style0 from "./AppNotificationToasts.vue?vue&type=style&index=0&id=c2768fb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports